import React from 'react';
import moment from 'moment';

const dateFormat = 'hh:mma, DD MMM YYYY';

const UpcomingAppointments = ({ survivingCustomer, duplicates, cellClassName }) => (
  <div className="c-table-card__row c-table-card__row--bordered">
    <div className="c-table-card__cell u-2/12">
      <div>Upcoming Appointments</div>
    </div>
    <div className="c-table-card__cell u-3/12 u-pv">
      <div className="u-type--semibold">Upcoming apointments after merge</div>
      {
        survivingCustomer.appointments.map((appt, idx) => (
          <div key={idx}>
            {appt.serviceName}&nbsp;
            by {appt.barber}&nbsp;
            {moment(appt.dateTime).format(dateFormat)}
          </div>
        ))
      }
    </div>
    {
      duplicates.map(d => (
        <div key={d.id} className={cellClassName}>
          {
            d.appointments.map((appt, idx) => (
              <div key={idx}>
                {appt.serviceName} by {appt.barber}&nbsp;
                {moment(appt.dateTime).format(dateFormat)}
              </div>
            ))
          }
        </div>
      ))
    }
  </div>
);

export default UpcomingAppointments;
